import { render, staticRenderFns } from "./DnelDmelTable.vue?vue&type=template&id=1856c556&scoped=true"
import script from "./DnelDmelTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DnelDmelTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1856c556",
  null
  
)

export default component.exports